export default __webpack_public_path__ + "static/6645-dc9baebc43fa548efd3eb003b279af6d.jpg";